<template>
    <div class="component">
        <vue-headful
        title="Edit theme | W&S Docs"
        />
        <div v-if="loading" class="loading">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="result" class="alert alert-secondary text-success font-weight-bold" role="alert">
            Тема успешно изменена!
        </div>
        <div class="form-group">
            <router-link class="btn bg-dark text-white" to="/admin/themes">Вернуться назад</router-link>
        </div>
        <div class="form" v-for="theme in ThemeByIDGet" :key="theme.theme_id">
            <div class="form-group d-flex flex-column">
                <label for="title">Введите название</label>
                <div class="d-flex small">
                    <b>Текущее название:</b><span class="text-secondary ml-1">{{ theme.theme_title }}</span>
                </div>
                <input id="title" type="text" class="form-control" placeholder="Введите название" v-model="title"/>
            </div>
            <div class="form-group d-flex flex-column">
                <label for="link">Введите краткий адрес</label>
                <div class="d-flex small">
                    <b>Текущеий краткий адрес:</b><span class="text-secondary ml-1">{{ theme.theme_link }}</span>
                </div>
                <input id="link" type="text" class="form-control" placeholder="Введите краткий адрес" v-model="link"/>
                <small class="form-text text-muted">Например: user.get</small>
            </div>
            <div class="form-group d-flex flex-column">
                <label for="desc">Введите описание</label>
                <div class="d-flex small">
                    <b>Текущее описание:</b><span class="text-secondary ml-1" v-if="theme.theme_desc">{{ theme.theme_desc }}</span><span class="text-secondary ml-1" v-else>отсутствует</span>
                </div>
                <input id="desc" type="text" class="form-control" placeholder="Введите краткий адрес" v-model="desc"/>
            </div>
            <button class="btn btn-dark" id="submit_btn" v-on:click="EditTheme">Редактировать тему</button>

        </div>
    </div>
</template>

<script>
  export default {
    name: "ThemeEdit",
    props: ['theme_id_q'],
    data() {
        return {
            theme_id: this.theme_id_q,
            title: '',
            link: '',
            desc: '',
            result: null,
            loading: true,
        };
    },
    computed: {
        ThemeByIDGet: function () {
            return this.$store.getters.ThemeByIDGet;
        },
        ThemeErrorGet: function () {
            return this.$store.getters.ThemeErrorGet;
        },
        ThemeSuccessGet: function () {
            return this.$store.getters.ThemeSuccessGet;
        },
        AdminAuthInfoGet: function () {
            return this.$store.getters.AdminAuthInfoGet;
        },
    },
    methods: {
        EditTheme: function () {
            let AdminID = this.AdminAuthInfoGet.AdminID,
            AdminToken = this.AdminAuthInfoGet.AdminToken;
            this.$store.dispatch('ThemeEditAct', [this.theme_id, this.title, this.link, this.desc, AdminID, AdminToken]);

            if (this.ThemeSuccessGet === true && this.ThemeErrorGet.length === 0) {
              this.result = true;
              this.$store.dispatch('ThemeByIDAct', this.theme_id_q);
          }
      },
  },
  mounted() {
    this.$store.dispatch('ThemeByIDAct', this.theme_id);
    this.loading = false;
},
watch: {
    theme_id_q: function() {
        this.$store.dispatch('ThemeByIDAct', this.theme_id);
        this.$store.getters.ThemeByIDGet;
    },
},
}
</script>

<style scoped>

</style>
